import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: white;
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  max-width: 1080px;
  padding: 143px 180px;
  margin: auto;
`;

export const Title = styled(Typography.Title)`
  text-align: center;
`;

export const Description = styled(Typography.BodyText)`
  text-align: center;
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled(Typography.Title)``;

export const SectionRow = styled.div`
  width: 100%;
  background-color: var(--mode-bg-neutral-weaker);
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  padding: 20px 32px;

  button,
  a {
    justify-content: end;
    width: max-content;
    margin-left: auto;
  }
`;

export const SectionRowIdentifier = styled(Typography.BodyText)`
  text-transform: uppercase;
`;

export const SectionRowDate = styled(Typography.BodyText)``;

export const SectionRowPrice = styled(Typography.BodyText)``;

export const Stripe3DS = styled.iframe`
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
